import {
  EarlyAccessStateTypes,
  EarlyAccessCreateUserTypes,
} from '../actions/types';

/**
 * Initial state for Early Access page
 * @typedef {Object} EarlyAccessPageState
 * @property {string|null} email - User's email address
 * @property {boolean} loading - Whether a request is in progress
 * @property {boolean} error - Whether an error has occurred
 * @property {boolean} success - Whether the request was successful
 */
const initialState = {
  email: null,
  loading: false,
  error: false,
  success: false,
  earlyAccessStep: 1,
  earlyAccessCreateUserStep: 1,
};

/**
 * Reducer for Early Access page state
 * @param {EarlyAccessPageState} state - Current state
 * @param {Object} action - Action object
 * @returns {EarlyAccessPageState} New state
 */
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case EarlyAccessStateTypes.EARLY_ACCESS_UPDATE_EMAIL: {
      const { email } = action;
      return {
        ...state,
        email,
      };
    }
    case EarlyAccessStateTypes.EARLY_ACCESS_REQUEST_IS_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case EarlyAccessStateTypes.EARLY_ACCESS_REQUEST_HAS_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        accountExists: !!action.accountExists,
        success: false,
      };
    }
    case EarlyAccessStateTypes.EARLY_ACCESS_REQUEST_IS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    }
    case EarlyAccessStateTypes.EARLY_ACCESS_RESET_ERROR: {
      return {
        ...state,
        error: false,
        accountExists: false,
      };
    }
    case EarlyAccessStateTypes.EARLY_ACCESS_STEP: {
      const { earlyAccessStep } = action;
      return {
        ...state,
        earlyAccessStep,
      };
    }
    case EarlyAccessCreateUserTypes.EARLY_ACCESS_CREATE_USER_STEP: {
      const { earlyAccessCreateUserStep } = action;
      return {
        ...state,
        earlyAccessCreateUserStep,
      };
    }
    default: {
      return state;
    }
  }
};
